import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faArrowLeft,
  faCancel,
  faBars,
  faShippingFast,
  faHandHolding,
  faMoneyCheckDollar,
  faFileWord,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import {
  listarOrdenesServicio,
  listarOrdenesServicioPorCorreoConsultorio,
  listarOrdenesServicioPorCorreoDoctor,
  listarOrdenesServicioPorCorreoMensajero,
} from "../../api/ordenesServicio";
import { listarServiciosFolio } from "../../api/servicios";
import { Button, Dropdown, Badge, Modal, Table } from "react-bootstrap";
import { withRouter } from "../../utils/withRouter";
import EliminarOrdenServicio from "./EliminarOrdenServicio";
import ModificarOrdenServicio from "./ModificarOrdenServicio";
import EntregarOrdenServicio from "./EntregarOrdenServicio";
import BasicModal from "../Modal/BasicModal/BasicModal";
import { Load } from "../load/load";
import { getTokenApi, obtenidusuarioLogueado } from "../../api/auth";
import { obtenerUsuario } from "../../api/usuarios";
import { toast } from "react-toastify";
import "./style.css";
import ImageVisualizer from "./ImageVisualizer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ProgresoOrden from "./progreso/ProgresoOrden";
import MaterialEntrega from "./material/MaterialEntrega";
import PagosOrdenesM from "./pagosOrdenesM/PagosOrdenesM";
import ProcesoCancelacionOrdenServicio from "./ProcesoCancelacionOrdenServicio";
import AsignarRetrabajo from "./AsignarRetrabajo";
import ActualizarEstadoCambiosOrdenServicio from "./ActualizarEstadoCambiosOrdenServicio";
import FechaEntrega from "./FechaEntrega";
import "dayjs/locale/es";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { listarDiasFestivos } from "../../api/diasFestivos";

function TblOrdenesServicio(props) {
  const { location, history } = props;
  
  dayjs.locale("es"); // use Spanish locale globally
  dayjs.extend(localizedFormat);

  const [listarOrdenes2, setListOrdenes2] = useState([]);

  const obtenerOrdenesServicio2 = async () => {
    try {
        const response = await listarDiasFestivos();
        const { data } = response;
        setListOrdenes2(formatModelOrdenes2(data));
    } catch (e) {
        console.error('Error al obtener las órdenes de servicio:', e);
    }
};

useEffect(() => {
    obtenerOrdenesServicio2();
}, []);

  const [loading, setLoading] = useState(true);

  const [tipoUsuario, setTipoUsuario] = useState("");
  const [correoUsuario, setCorreoUsuario] = useState("");

  const obtenerDatosUsuario = () => {
    try {
      obtenerUsuario(obtenidusuarioLogueado(getTokenApi()))
        .then((response) => {
          const { data } = response;
          setTipoUsuario(data.tipo);
          setCorreoUsuario(data.email);
        })
        .catch((e) => {
          if (e.message === "Network Error") {
            //console.log("No hay internet")
            toast.error("Conexión al servidor no disponible");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    obtenerDatosUsuario();
  }, []);

  useEffect(() => {
    // Simula una carga de datos
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const [listarOrdenes, setListOrdenes] = useState([]);

  const obtenerOrdenesServicio = () => {
    if (tipoUsuario == "administrador" || tipoUsuario == "mesa de control") {
      try {
        listarOrdenesServicio()
          .then((response) => {
            const { data } = response;

            if (!listarOrdenes && data) {
              setListOrdenes(formatModelOrdenes(data));
            } else {
              const datosOrdenes = formatModelOrdenes(data);
              setListOrdenes(datosOrdenes);
            }
          })
          .catch((e) => { });
      } catch (e) { }
    } else if (tipoUsuario == "consultorio") {
      try {
        listarOrdenesServicioPorCorreoConsultorio(correoUsuario)
          .then((response) => {
            const { data } = response;

            if (!listarOrdenes && data) {
              setListOrdenes(formatModelOrdenes(data));
            } else {
              const datosOrdenes = formatModelOrdenes(data);
              setListOrdenes(datosOrdenes);
            }
          })
          .catch((e) => { });
      } catch (e) { }
    } else if (tipoUsuario == "doctor") {
      try {
        listarOrdenesServicioPorCorreoDoctor(correoUsuario)
          .then((response) => {
            const { data } = response;

            if (!listarOrdenes && data) {
              setListOrdenes(formatModelOrdenes(data));
            } else {
              const datosOrdenes = formatModelOrdenes(data);
              setListOrdenes(datosOrdenes);
            }
          })
          .catch((e) => { });
      } catch (e) { }
    } else if (tipoUsuario == "mensajero") {
      try {
        listarOrdenesServicioPorCorreoMensajero(correoUsuario)
          .then((response) => {
            const { data } = response;

            if (!listarOrdenes && data) {
              setListOrdenes(formatModelOrdenes(data));
            } else {
              const datosOrdenes = formatModelOrdenes(data);
              setListOrdenes(datosOrdenes);
            }
          })
          .catch((e) => { });
      } catch (e) { }
    }
  };

  useEffect(() => {
    obtenerOrdenesServicio();
  }, [location, correoUsuario]);

  // Configurando animacion de carga
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);

  const cargarDatos = () => {
    const timeout = setTimeout(() => {
      setRows(listarOrdenes);
      setPending(false);
    }, 0);
    return () => clearTimeout(timeout);
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  //Para el modal
  const [showModal, setShowModal] = useState(false);
  const [contentModal, setContentModal] = useState(null);
  const [titulosModal, setTitulosModal] = useState(null);

  const registroOrden = (content) => {
    setTitulosModal("Registrar orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const procesoCancelacionOrden = (content) => {
    setTitulosModal("Proceso cancelacion orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const modificarOrden = (content) => {
    setTitulosModal("Modificar orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const verOrden = (content) => {
    setTitulosModal("Detalles de la orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const eliminarOrden = (content) => {
    setTitulosModal("Eliminar orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const cancelarOrden = (content) => {
    setTitulosModal("Cancelar orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const transferirOrden = (content) => {
    setTitulosModal("Transferir orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const entregarOrden = (content) => {
    setTitulosModal("Entregar orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const recibirPago = (content) => {
    setTitulosModal("Pago de orden de cliente");
    setContentModal(content);
    setShowModal(true);
  };

  const recibirMaterial = (content) => {
    setTitulosModal("Recibir material de la orden");
    setContentModal(content);
    setShowModal(true);
  };

  const progresoOrden = (content) => {
    setTitulosModal("Progreso");
    setContentModal(content);
    setShowModal(true);
  };

  const asignarRetrabajo = (content) => {
    setTitulosModal("Asignar retrabajo");
    setContentModal(content);
    setShowModal(true);
  };

  const actualizarEstadoCambios = (content) => {
    setTitulosModal("Confirma los cambios");
    setContentModal(content);
    setShowModal(true);
  };

  const [mostrarPrimerDiv, setMostrarPrimerDiv] = useState(true);
  const [idOrdenSel, setidOrdenSel] = useState("");

  const handleClick = (tableMeta) => {
    // Verifica si tableMeta es undefined antes de acceder a rowData
    if (tableMeta && tableMeta.rowData) {
      // Accede a la información de la fila actual
      const rowData = tableMeta.rowData;

      // Obtén el valor de la primera columna (supongamos que es la posición 0 del array)
      const valorPrimeraColumna = rowData[0];

      // Actualiza la variable con el valor de la primera columna
      setidOrdenSel(valorPrimeraColumna);

      // Puedes hacer cualquier otra lógica que necesites con el valor obtenido
      console.log("Valor de la primera columna:", valorPrimeraColumna);
    } else {
      console.error("tableMeta o tableMeta.rowData es undefined");
    }
    setMostrarPrimerDiv(!mostrarPrimerDiv);
  };

  console.log(tipoUsuario);

  const [listarServicios, setListServicios] = useState([]);

  const obtenerServicios = (folio) => {
    try {
      listarServiciosFolio(folio)
        .then((response) => {
          const { data } = response;
          console.log(data);
          if (!listarServicios && data) {
            setListServicios(formatModelServicios(data));
          } else {
            const datosServicios = formatModelServicios(data);
            setListServicios(datosServicios);
          }
        })
        .catch((e) => { });
    } catch (e) { }
  };

  const [showModal2, setShowModal2] = useState(false);

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "folio",
      label: "FOLIO",
    },
    {
      name: "fecha",
      label: "FECHA DE ALTA",
      options: {
        customBodyRender: (value, tableMeta) => {

          return (
            <>
              {dayjs(value).format("LL")}
            </>
          );
        },
      },
    },
    {
      name: "localidad",
      label: "CONSULTORIO",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "nombreDoctor",
      label: "NOMBRE DEL DOCTOR",
    },
    {
      name: "nombrePaciente",
      label: "NOMBRE DEL PACIENTE",
    },
    {
      name: "tipoDentadura",
      label: "TIPO DE DENTADURA",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "servicios",
      label: "TRABAJOS",
      options: {
        customBodyRender: (value, tableMeta) => (
          <Button
            variant="link"
            onClick={() => {
              obtenerServicios(tableMeta.rowData[1]);
              setShowModal2(true);
            }}
          >
            Mostrar información detallada
          </Button>
        ),
      },
    },
    {
      name: "recibio",
      label: "RECIBIO MATERIAL",
    },
    {
      name: "fechaEntrada",
      label: "FECHA DE RECEPCION",
      options: {
        customBodyRender: (value, tableMeta) => {

          return (
            <>
              {dayjs(value).format("LL")}
            </>
          );
        },
      },
    },
    {
      name: "correoDoctor",
      label: "EMAIL DOCTOR",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "correoConsultorio",
      label: "CORREO CONSULTORIO",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "Imagenes",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Button variant="link" onClick={() => handleClick(tableMeta)}>
                Clic para visualizar imagenes
              </Button>
            </>
          );
        },
      },
    },
    {
      name: "estado",
      label: "ESTADO DEL PEDIDO",
      options: {
        customBodyRender: (value) => {
          const estado = value;

          let estiloTexto = "";
          let estadoTexto = "";

          if (estado == "1") {
            estiloTexto = "Orden nueva";
            estadoTexto = "Orden nueva";
          } else if (estado == "2") {
            estiloTexto = "Recoleccion asignada";
            estadoTexto = "Recoleccion asignada";
          } else if (estado == "3") {
            estiloTexto = "Orden entregada";
            estadoTexto = "Orden entregada";
          } else if (estado == "4") {
            estiloTexto = "Fabricando";
            estadoTexto = "Fabricando";
          } else if (estado == "5") {
            estiloTexto = "Orden finalizada";
            estadoTexto = "Orden finalizada";
          } else if (estado == "0") {
            estiloTexto = "Orden cancelada";
            estadoTexto = "Orden cancelada";
          } else if (estado == "6") {
            estiloTexto = "En proceso";
            estadoTexto = "En proceso";
          } else if (estado == "7") {
            estiloTexto = "En ruta de entrega";
            estadoTexto = "En ruta de entrega";
          } else if (estado == "8") {
            estiloTexto = "Entregado";
            estadoTexto = "Entregado";
          } else if (estado == "9") {
            estiloTexto = "Retrabajo";
            estadoTexto = "Retrabajo";
          }
          return (
            <>
              <Badge
                bg={
                  estado == "1"
                    ? "info"
                    : estado == "2"
                      ? "warning"
                      : estado == "3"
                        ? "primary"
                        : estado == "4"
                          ? "secondary"
                          : estado == "5"
                            ? "dark"
                            : estado == "6"
                              ? "primary"
                              : estado == "7"
                                ? "light"
                                : estado == "8"
                                  ? "success"
                                  : estado == "9" ?
                                    "secondary"
                                    : "danger"
                }
              //className="estado"
              >
                {estiloTexto}
              </Badge>
            </>
          );
        },
      },
    },
    {
      name: "progreso",
      label: "Progreso de orden",
      options: {
        customBodyRender: (value, tableMeta) => (
          <Button
            variant="link"
            onClick={() =>
              progresoOrden(
                <ProgresoOrden
                  history={history}
                  setShow={setShowModal}
                  data={tableMeta.rowData[1]}
                />
              )
            }
          >
            Ver progreso
          </Button>
        ),
      },
    },
    {
      name: "telefonoDoctor",
      label: "TELEFONO DOCTOR",
      options: {
        customBodyRender: (value) => {
          const phoneNumber = "+52" + value; // Elimina caracteres no numéricos
          const whatsappLink = `https://wa.me/${phoneNumber}`;
          return (
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          );
        },
      },
    },
    {
      name: "cancelacion",
      label: "CANCELACION",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "cambios",
      label: "CAMBIOS",
      options: {
        customBodyRender: (value) => {
          const estado = value;

          let estiloTexto = "";
          let estadoTexto = "";

          if (estado == "1") {
            estiloTexto = "Cambios aceptados";
            estadoTexto = "Cambios aceptados";
          } else if (estado == "2") {
            estiloTexto = "Cambios aun no aceptados";
            estadoTexto = "Cambios aun no aceptados";
          } else if (estado == "0") {
            estiloTexto = "Sin cambios disponibles";
            estadoTexto = "Sin cambios disponibles";
          }
          return (
            <>
              <Badge
                bg={
                  estado == "1"
                    ? "success"
                    : estado == "2"
                      ? "info"
                      : "warning"
                }
              //className="estado"
              >
                {estiloTexto}
              </Badge>
            </>
          );
        },
      },
    },
    {
      name: "aprobado",
      label: "APROBADO",
    },
    {
      name: "direccionConsultorio",
      label: "DIRECCION",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "dia",
      label: "FECHA DE ENTREGA",
      options: {
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          const fecha = tableMeta.rowData[2];
           const ruta = tableMeta.rowData[19];

          return <FechaEntrega id={id} fecha={fecha} ruta={ruta} listarOrdenes={listarOrdenes2} />;
        },
      },
    },
    {
      name: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tipoUsuario !== "consultorio" &&
            tipoUsuario !== "cProduccion" &&
            tipoUsuario !== "doctor" &&
            tipoUsuario !== "mensajero" &&
            tableMeta.rowData[13] !== "0" ? (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  style={{ backgroundColor: "#0c1b30", borderColor: "#0c1b30" }}
                  id="dropdown-basic"
                >
                  <FontAwesomeIcon icon={faBars} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {(tipoUsuario === "mesa de control" || tipoUsuario === "administrador") && (
                    <>
                      {tipoUsuario != "administrador" && tableMeta.rowData[17] == "2" && (
                        <Dropdown.Item
                          onClick={() =>
                            actualizarEstadoCambios(
                              <ActualizarEstadoCambiosOrdenServicio
                                history={history}
                                aprobado={"mesa de control"}
                                setShow={setShowModal}
                                data={tableMeta.rowData}
                              />
                            )
                          }
                        >
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "#007bff" }}
                          />
                          &nbsp;Confirmar cambios
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        onClick={() =>
                          modificarOrden(
                            <ModificarOrdenServicio
                              history={history}
                              setShow={setShowModal}
                              data={tableMeta.rowData}
                            />
                          )
                        }
                      >
                        <FontAwesomeIcon
                          icon={faPen}
                          style={{ color: "#fd7e14" }}
                        />
                        &nbsp;Editar Orden
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          eliminarOrden(
                            <EliminarOrdenServicio
                              history={history}
                              setShow={setShowModal}
                              data={tableMeta.rowData}
                            />
                          )
                        }
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "#dc3545" }}
                        />
                        &nbsp; Cancelar Orden
                      </Dropdown.Item>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : tipoUsuario === "mensajero" && tableMeta.rowData[13] === "4" ? (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  style={{ backgroundColor: "#0c1b30", borderColor: "#0c1b30" }}
                  id="dropdown-basic"
                >
                  <FontAwesomeIcon icon={faShippingFast} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() =>
                      entregarOrden(
                        <EntregarOrdenServicio
                          history={history}
                          setShow={setShowModal}
                          data={tableMeta.rowData}
                        />
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={faPen}
                      style={{ color: "#fd7e14" }}
                    />
                    &nbsp;Entregar orden
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      recibirPago(
                        <PagosOrdenesM
                          history={history}
                          setShow={setShowModal}
                          data={tableMeta.rowData}
                        />
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={faMoneyCheckDollar}
                      style={{ color: "#28a745" }}
                    />
                    &nbsp;Recibir pago
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : tipoUsuario === "mensajero" && tableMeta.rowData[13] === "2" ? (
            <>
              <Dropdown>
                <Dropdown.Toggle
                  style={{ backgroundColor: "#0c1b30", borderColor: "#0c1b30" }}
                  id="dropdown-basic"
                >
                  <FontAwesomeIcon icon={faShippingFast} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() =>
                      recibirMaterial(
                        <MaterialEntrega
                          history={history}
                          setShow={setShowModal}
                          data={tableMeta.rowData}
                        />
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={faHandHolding}
                      style={{ color: "#fd7e14" }}
                    />
                    &nbsp;Recibir material
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : tableMeta.rowData[16] === "1" && tipoUsuario === "consultorio" ? (
            <Dropdown>
              <Dropdown.Toggle
                style={{ backgroundColor: "#0c1b30", borderColor: "#0c1b30" }}
                id="dropdown-basic"
              >
                <FontAwesomeIcon icon={faBars} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() =>
                    procesoCancelacionOrden(
                      <ProcesoCancelacionOrdenServicio
                        history={history}
                        setShow={setShowModal}
                        data={tableMeta.rowData}
                      />
                    )
                  }
                >
                  <FontAwesomeIcon
                    icon={faCancel}
                    style={{ color: "#dc3545" }}
                  />
                  &nbsp;Cancelar orden
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : tipoUsuario === "doctor" ? (
            <Dropdown>
              <Dropdown.Toggle
                style={{ backgroundColor: "#0c1b30", borderColor: "#0c1b30" }}
                id="dropdown-basic"
              >
                <FontAwesomeIcon icon={faBars} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {tableMeta.rowData[17] == "2" && (
                  <Dropdown.Item
                    onClick={() =>
                      actualizarEstadoCambios(
                        <ActualizarEstadoCambiosOrdenServicio
                          history={history}
                          aprobado={"el cliente"}
                          setShow={setShowModal}
                          data={tableMeta.rowData}
                        />
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ color: "#007bff" }}
                    />
                    &nbsp;Confirmar cambios
                  </Dropdown.Item>
                )}
                {tableMeta.rowData[13] == "8" && (
                  <Dropdown.Item
                    onClick={() =>
                      asignarRetrabajo(
                        <AsignarRetrabajo
                          history={history}
                          setShow={setShowModal}
                          data={tableMeta.rowData}
                        />
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={faFileWord}
                      style={{ color: "#FFA500" }}
                    />
                    &nbsp;Asignar Retrabajo
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            "No disponibles"
          );
        },
      },
    },
    {
      name: "cargo",
      label: "CARGO",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
  ];

  const theme = useTheme();
  const isSmOrDown = useMediaQuery(theme.breakpoints.down("sm"));

  const options = {
    filterType: "checkbox",
    responsive: isSmOrDown && "standard",
    selectableRows: isSmOrDown ? "none" : "multiple",
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `ordenar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "RESTAURAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  return (
    <>
      <div>
        {mostrarPrimerDiv ? (
          <div>
            {loading && <Load />}
            <h1>Ordenes de cliente</h1>
            {tipoUsuario == "doctor" && (
              <h2>Si tienes cambios pendientes por confirmar, hazlo antes de las 12:00PM o las entregas se reprogramaran a la segunda visita</h2>
            )}
            <div className="divTabla">
              <MUIDataTable
                title={"Lista de ordenes de cliente registradas"}
                data={listarOrdenes}
                columns={columns}
                options={options}
              />
            </div>
            <BasicModal
              show={showModal}
              setShow={setShowModal}
              title={titulosModal}
            >
              {contentModal}
            </BasicModal>
            <Modal
              show={showModal2}
              onHide={() => setShowModal2(false)}
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Información detallada</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Departamento</th>
                        <th>Pieza</th>
                        <th>Sistema de color</th>
                        <th>Diente</th>
                        <th>Tono Inferior</th>
                        <th>Tono Medio</th>
                        <th>Tono Superior</th>
                        <th>Descripción de protesis</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listarServicios.map((selected, index) => (
                        <tr key={index}>
                          <td>{selected.clasificacion}</td>
                          <td>{selected.pieza}</td>
                          <td>{selected.sistemaColor}</td>
                          <td>{selected.diente}</td>
                          <td>{selected.tonoInferior}</td>
                          <td>{selected.tonoMedio}</td>
                          <td>{selected.tonoSuperior}</td>
                          <td>{selected.descripcionAdicional}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowModal2(false)}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: "2px",
                left: "10px",
              }}
            >
              <Button
                variant="primary"
                style={{ color: "#fff", textDecoration: "none" }}
                onClick={handleClick}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </div>
            <h2 style={{ textAlign: "center", marginTop: "2%" }}>
              Imagenes de orden de cliente
            </h2>
            <ImageVisualizer idOrdenSel={idOrdenSel} />
          </div>
        )}
      </div>
    </>
  );
}

function formatModelOrdenes(data) {
  const dataTemp = [];
  data.forEach((data) => {
    dataTemp.push({
      id: data._id,
      folio: data.folio,
      fecha: data.fecha,
      localidad: data.localidad,
      nombreDoctor: data.nombreDoctor,
      nombrePaciente: data.nombrePaciente,
      tipoDentadura: data.tipoDentadura,
      servicios: data.servicios,
      otros: data.otros,
      recibio: data.recibio,
      fechaEntrada: data.fechaEntrada,
      correoDoctor: data.correoDoctor,
      correoConsultorio: data.correoConsultorio,
      estado: data.estado,
      telefonoDoctor: data.telefonoDoctor,
      cancelacion: data.cancelacion,
      cargo: data.cargoOrden,
      cambios: !data.cambios ? "0" : data.cambios,
      aprobado: !data.aprobado ? "No disponible" : data.aprobado,
      direccionConsultorio: data.direccionConsultorio.municipio
    });
  });
  return dataTemp;
}

function formatModelServicios(data) {
  return data.map((item) => {
    const dienteArray = item.diente;
    let diente = "";

    if (Array.isArray(dienteArray)) {
      diente = dienteArray
        .map(d => d.match(/\d+/)) // Extract numbers from each string
        .filter(Boolean)          // Remove any null values resulting from no match
        .join(", ");              // Join the numbers with comma and space
    }

    return {
      id: item._id,
      folio: item.folio,
      clasificacion: item.clasificacion,
      material: item.material,
      pieza: item.pieza,
      precio: item.precio,
      descripcionAdicional: item.descripcionAdicional,
      sistemaColor: item.sistemaColor,
      distencion: item.distencion,
      diente: diente,
      tonoInferior: item.tonoInferior,
      tonoMedio: item.tonoMedio,
      tonoSuperior: item.tonoSuperior,
      imagenEsquema: item.imagenEsquema,
      imagenDiente: item.imagenDiente,
    };
  });
}

function formatModelOrdenes2(data) {
  return data.map(data => ({
      id: data._id,
      fecha: data.fecha,
      descripcion: data.descripcion,
      estado: data.estado,
  }));
}

export default withRouter(TblOrdenesServicio);